import { call, put, takeLatest } from 'redux-saga/effects';
import { usersService } from '../../api/services/users';
import {
  fetchUsersRequest,
  fetchUsersSuccess,
  fetchUsersFailure,
  inviteUserRequest,
  inviteUserSuccess,
  inviteUserFailure,
  deleteUserRequest,
  deleteUserSuccess,
  deleteUserFailure,
} from '../slices/usersSlice';

// Fetch users saga
function* fetchUsersSaga() {
  try {
    const response = yield call(usersService.getUsers);
    yield put(fetchUsersSuccess(response));
  } catch (error) {
    yield put(fetchUsersFailure(error instanceof Error ? error.message : 'Failed to fetch users'));
  }
}

// Invite user saga
function* inviteUserSaga(action: ReturnType<typeof inviteUserRequest>) {
  try {
    const response = yield call(usersService.inviteUser, action.payload);
    yield put(inviteUserSuccess(response));
  } catch (error) {
    yield put(inviteUserFailure(error instanceof Error ? error.message : 'Failed to invite user'));
  }
}

// Delete user saga
function* deleteUserSaga(action: ReturnType<typeof deleteUserRequest>) {
  try {
    yield call(usersService.deleteUser, action.payload);
    yield put(deleteUserSuccess(action.payload));
  } catch (error) {
    yield put(deleteUserFailure(error instanceof Error ? error.message : 'Failed to delete user'));
  }
}

// Users saga watcher
export function* usersSaga() {
  yield takeLatest(fetchUsersRequest.type, fetchUsersSaga);
  yield takeLatest(inviteUserRequest.type, inviteUserSaga);
  yield takeLatest(deleteUserRequest.type, deleteUserSaga);
}
